import React from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';

import { formatDate, parseDate, isInvalidDate, truncate, parseRawDate, compareDates, formatRawDateTime } from '../../data/dateutils';
import { getSrchTokens, createSrchStr, matchSrchTokens } from '../../data/localsearch';

import LookupInput from './lookupinput';

const EMPTY_LIST = Immutable.List([]);

export default class DateInput extends React.PureComponent {
	constructor() {
		super();
		this.state = {
			text: null,
			textWithTime: null,
			presetRows: EMPTY_LIST
		};

		this.onChange = this.onChange.bind(this);
		this.getText = this.getText.bind(this);
		this.getRows = this.getRows.bind(this);
		this.onBlur = this.onBlur.bind(this);
		this.onTextChange = this.onTextChange.bind(this);
		this.onKeyDown = this.onKeyDown.bind(this);
	}

	onKeyDown(e) {
		if (e.keyCode === 13) {
			this.processText();
		}
	}

	onTextChange(text) {
		this.state.text = text;
	}

	hasValueChanged(value) {
		const currValue = parseRawDate(this.props.value);
		if (!currValue) {
			return !!value;
		}
		if (this.props.withTime) {
			return compareDates(value, currValue);
		} else {
			return compareDates(value, truncate(currValue));
		}
	}

	processText() {
		if (this.state.text === null) {
			return;
		}
		let text = this.state.text.trim();
		if (text === '') {
			this.onChange(null);
		} else {
			var value = parseDate(text);
			if (!isInvalidDate(value)) {
				if (this.hasValueChanged(value)) {
					console.log('changing');
					this.onChange(value);
				}
			}
		}
	}
	onBlur(e) {
		this.processText();
		if (this.props.onBlur) {
			this.props.onBlur(e);
		}
	}

	onChange(value, filter) {
		this.state.text = null;
		if (typeof this.props.onChange === 'function') {
			if (value) {
				this.props.onChange(this.props.withTime ? formatRawDateTime(value) : value);
			} else {
				this.props.onChange(null);
			}
		}
	}

	getText(value) {
		//console.log('getText', value);
		if (!value) {
			return '';
		}
		return formatDate(value, this.props.withTime);
	}

	getRows(filter) {
		const tokens = [getSrchTokens(filter).join('')];
		return this.state.presetRows.filter(row => matchSrchTokens(tokens, row.get('srchStr')));
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		if (nextProps.presets === prevState.presets) {
			return {
				textWithTime: formatDate(nextProps.value, true),
			};
		}
		return {
			text: null,
			textWithTime: formatDate(nextProps.value, true),
			presets: nextProps.presets,
			presetRows: createSrchStr(Immutable.fromJS(nextProps.presets.map(item => Immutable.fromJS({
				key: item.value,
				cells: [item.text]
			}))))
		};
	}

	render() {
		return <LookupInput
			getRows={this.getRows}
			getText={this.getText}
			noDropDown={!this.state.presetRows || this.state.presetRows.size === 0}
			value={this.props.value ? this.props.value.valueOf() : null}
			onChange={this.onChange}
			hideEmptyPopup={true}
			hint={this.state.textWithTime}
			onTextChange={this.onTextChange}
			onBlur={this.onBlur}
			readOnly={this.props.readOnly}
			onKeyDown={this.onKeyDown}
			placeholder={this.props.placeholder}
			size={this.props.size}
		/>;
	}
}
